// Shared helpers for the platform-admin UI
export const PLAN_TIERS = [
  { key: "essential", label: "Essential", bg: "#DBEAFE", fg: "#1E40AF" },
  { key: "pro", label: "Pro", bg: "#FFEDD5", fg: "#C2410C" },
  { key: "enterprise", label: "Enterprise", bg: "#DCFCE7", fg: "#166534" },
];

export const PLATFORM_STAFF_ROLES = [
  { key: "super_admin", label: "Admin", hint: "Full control + manage staff" },
  { key: "platform_manager", label: "Manager", hint: "Control + manage customers" },
  { key: "platform_staff", label: "Staff", hint: "Help customers & enquiries" },
  { key: "platform_observer", label: "Observer", hint: "Read only" },
  { key: "platform_sales", label: "Sales", hint: "Manage costing + invoice" },
];

const PW_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
export function generatePassword(len = 12) {
  const arr = new Uint32Array(len);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, (n) => PW_CHARS[n % PW_CHARS.length]).join("");
}

export function tierMeta(key) {
  const known = PLAN_TIERS.find((t) => t.key === key);
  if (known) return known;
  // Unknown / custom tier slugs (created via the Subscription tiers tab).
  // Fall back to a neutral pastel pill and Title-Case the label so the
  // pill still reads nicely on the firms list.
  if (!key) return PLAN_TIERS[0];
  const label = String(key).replace(/[-_]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return { key, label, bg: "#EDE9FE", fg: "#5B21B6" };
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function toDateInput(iso) {
  if (!iso) return "";
  return new Date(iso).toISOString().slice(0, 10);
}

export function fromDateInput(v) {
  if (!v) return null;
  return new Date(v + "T00:00:00.000Z").toISOString();
}
